import React from 'react';

import './real-rotate.scss';

import life from '../../../f/img/target/real/life.png'
import green from '../../../f/img/target/real/green.png'
import city from '../../../f/img/target/real/city.png'
import text from '../../../f/img/target/real/real-text2.png'
import poster from '../../../f/img/target/real/real-rotate.jpg'
import center from '../../../f/videos/target/real-rotate.mp4'



const DecorRealRotate = () => {

    return (
        <>
            <div className='img-wrapper'>
                <img src={city} className='city rotate-img' />
                <img src={green} className='green rotate-img' />
                <img src={life} className='life rotate-img' />
                <div className='border'>
                    <img src={text} className='state rotate-state' />
                </div>
                <div className='img-wrap'>
                    <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={poster}>
                        <source src={center} type='video/mp4' />
                    </video>
                    <div className='link-to-all'><a href='https://www.artlebedev.ru/real-estate/identities/' target='_blank'>Все проекты</a></div>
                </div>
            </div>
        </>
    );
}

export default DecorRealRotate;
